import { ColumnDef } from '@tanstack/react-table'
import { useDataTable, useTableState } from '../../Components/TanstackTable'

const useReportTable = <T>(columns: ColumnDef<T>[], data: T[]) => {
    const tableState = useTableState()
    const { table } = useDataTable<T>({ ...tableState, columns, data })
    return table
}

export default useReportTable
